import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ContactPermission} from '../../../../models/inbox';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {Channel} from '../../../../models/common';
import {UserService} from '../../../services/user.service';
import {ChannelStatus, FacebookAuthPreviousState, platformIconPath} from '../../../app.constants';
import {TranslateService} from '@ngx-translate/core';
import {ModalService} from '../../../services/modal/modal.service';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {AuthService} from '../../../core/auth.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'contact-permission-detail',
  templateUrl: './contact-permission-detail.component.html',
  styleUrls: ['./contact-permission-detail.component.scss']
})
export class ContactPermissionDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('ChannelConfirmPopup') ChannelConfirmPopup: AchooPopupComponent;
  @Input() contactPermission: ContactPermission;
  @Input() permissionToken: string;
  @Input() isDeletedOrError = false;
  @Output() openContactEvt: EventEmitter<any> = new EventEmitter();
  @Output() acceptCallback: EventEmitter<any> = new EventEmitter();
  @Output() declineCallback: EventEmitter<any> = new EventEmitter();
  showDeclineModal = false;
  listExistingChannel: Channel[] = [];
  isConfirmingInfluencerNameAndEmail: boolean;
  private isFbAuthFail = false;
  private confirmInfluencerNameAndEmailSubscription;

  constructor(private influencerService: InfluencerService,
              private userService: UserService,
              private auth: AuthService,
              private activatedRoute: ActivatedRoute,
              private translate: TranslateService,
              private modalService: ModalService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.error) {
        this.isFbAuthFail = true;
      }
    });
    const currentInfluencer = this.userService.getInfluencerInfo();
    if (currentInfluencer) {
      this.loadInfluencerChannels(currentInfluencer.id);
    }
    this.confirmInfluencerNameAndEmailSubscription = this.influencerService.confirmInfluencerNameAndEmailObserver
      .subscribe(res => {
      this.isConfirmingInfluencerNameAndEmail = res;
      });
  }

  ngAfterViewInit() {
    const localChannelAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
    if (localChannelAuthData) {
      this.modalService.openInCenter(this.ChannelConfirmPopup, null, 'campaign-confirm-popup');
      // remove the local auth data
      this.auth.removeInfluencerChannelAuthorizationLocalData();
    }
  }

  ngOnDestroy() {
    if (this.confirmInfluencerNameAndEmailSubscription) {
      this.confirmInfluencerNameAndEmailSubscription.unsubscribe();
    }
  }

  onDeclinePermission() {
    this.showDeclineModal = true;
  }

  onAcceptPermission() {
    const hasConfirmedAllChannels = this.listExistingChannel.length > 0
    && this.listExistingChannel.filter(cn => cn.type !== ChannelStatus.AUTHORIZED).length === 0;
    if (hasConfirmedAllChannels) {
      this.modalService.close();
      this.acceptCallback.emit(this.permissionToken);
    } else {
      this.modalService.openInCenter(this.ChannelConfirmPopup, null, 'campaign-confirm-popup');
    }
  }

  onConfirmChannel() {
    this.modalService.close();
    this.acceptCallback.emit(this.permissionToken);
  }

  acceptToDecline(evt) {
    this.showDeclineModal = false;
    this.declineCallback.emit(this.permissionToken);
  }

  openContact() {
    this.openContactEvt.emit();
  }

  closeDeclineModal() {
    this.showDeclineModal = false;
  }

  clickOutsideDeclineModal(evt) {
    if (!evt.target.classList.contains('decline-btn')) {
      this.closeDeclineModal();
    }
  }

  private loadInfluencerChannels(influencerId) {
    this.influencerService.getInfluencerChannels(influencerId).subscribe((res) => {
      this.listExistingChannel = res;
      const igChannels = this.listExistingChannel.filter(ec => ec.platform.id === platformIconPath.instagram.id);
      if (igChannels.length > 0) {
        const channelAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
        igChannels.forEach(cn => {
          if (channelAuthData && cn.id === channelAuthData.activeChannelId && this.isFbAuthFail) {
            cn.type = ChannelStatus.AUTHORIZE_FAILED;
          } else if (!this.auth.hasAuthorizedIgChannel(cn.id)) {
            // force to influencer always to authorize the ig channel before accepting to get the updated auth token
            cn.type = ChannelStatus.UNAUTHORIZE;
          }
        });
      }
    });
  }

  get acceptButtonLabel() {
    if (!this.listExistingChannel) {
      return this.translate.instant('common.btn.continue');
    }
    if (this.listExistingChannel.length === 0
      || this.listExistingChannel.filter(cn => cn.type !== ChannelStatus.AUTHORIZED).length > 0) {
      return this.translate.instant('common.btn.continue');
    } else {
      return this.translate.instant('common.btn.accept');
    }
  }

  closeNotification() {
    this.modalService.close();
  }

  get activePageBeforeAuthorizingFb() {
    return FacebookAuthPreviousState.ON_CONTACT_PERMISSION;
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/contact-permission/contact-permission-detail/contact-permission-detail.component.ts